<template>
    <section class="section">
      <div class="tile is-ancestor">
        <div class="tile is-vertical is-12">
          <div class="tile">
            <div class="tile is-parent is-vertical">
              <article class="tile is-child notification">
                <p class="title">🗞 News</p>
                <p class="subtitle">Welcome to our latest update!</p>
                <div v-if="!loadState" class="content">
                  <li v-for="(item, index) in news" :key="item[index]">{{ item }}</li>
                </div>
                <div v-else class="content">
                  <b-skeleton width="80%"></b-skeleton>
                  <b-skeleton width="60%"></b-skeleton>
                  <b-skeleton width="90%"></b-skeleton>
                </div>
              </article>
              <article class="tile is-child notification">
                <p class="title">👤 Your Profile</p>
                <p class="subtitle">Please keep your details up-to-date</p>
                <div v-if="!loadState">
                  <p>Name: {{LoggedInProfile.firstName}} {{LoggedInProfile.lastName}}</p>
                  <p>Company: {{LoggedInProfile.company}}</p>
                  <br/>
                </div>
                <div v-else class="content">
                  <b-skeleton width="40%"></b-skeleton>
                  <b-skeleton width="20%"></b-skeleton>
                  <b-skeleton width="30%"></b-skeleton>
                </div>
                <p>To edit, go to the full <router-link to="/profile">profile page</router-link>.</p>
              </article>
            </div>
            <div class="tile is-parent is-vertical is-7">
              <article class="tile is-child notification">
                <p class="title">📦 Your Orders</p>
                <p class="subtitle">Get started or view orders under preparation</p>
                <div class="content">
                  <p>
                    <router-link style="text-decoration: none;" to="/commissioning/firstPart">
                      <b-button label="Start a case study!" icon-pack="fas"  icon-left="rocket" class="button is-info"/>
                    </router-link>
                  </p>
                  <p>Go to your <router-link to="/orders">current orders</router-link>.</p>
                </div>
              </article>
              <article class="tile is-child notification">
                <p class="title">📬 Delivered Materials</p>
                <p class="subtitle">Access your delivered case studies</p>
                <div class="content">
                  <p style="opacity: 80%;"><i>It seems like you don't have any completed case studies yet. [hardcoded]</i></p>
                  <p>Go to the <router-link to="/delivered-material">delivered materials page</router-link>.</p>
                </div>
              </article>
            </div>
          </div>
          <div class="tile is-parent is-4">
            <article class="tile is-child notification is-info">
              <p class="title">📨 Contact Us</p>
              <p class="subtitle">Get in touch with us at any time</p>
              <div class="content">
                <p>
                  <b>Santeri Liukkonen</b><br/>Founder, CEO<br/>+358 41 4332 767<br/>alexander.liukkonen@gmail.com<br/>
                  <br/><b>ReferenceKit & Co.</b><br/>Paul-Heyse-Str. 34<br/>80336 München<br/>Deutschland
                </p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import * as firebase from "../../firebase"

export default {
  data: function() {
    return {
      news: "",
      loadState: true
    }
  },
  computed: {
    LoggedInProfile() {
      return this.$store.state.userProfile;
    },
  },
  created() {
    firebase.newsCollection.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.news = doc.data().NewsUpdate;
        this.loadState = false;
      });
    }).catch(function(error) {
      console.log(error);
      this.loadState = false; 
    });
  }
}
</script>